// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_back = /** @type {(inputs: {}) => string} */ () => {
	return `Back`
};

const el_back = /** @type {(inputs: {}) => string} */ () => {
	return `Πίσω`
};

const ru_back = /** @type {(inputs: {}) => string} */ () => {
	return `Назад`
};

const he_back = /** @type {(inputs: {}) => string} */ () => {
	return `חזרה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const back = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.back(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("back", locale)
	if (locale === "en") return en_back(inputs)
	if (locale === "el") return el_back(inputs)
	if (locale === "ru") return ru_back(inputs)
	if (locale === "he") return he_back(inputs)
	return "back"
};